import { render, staticRenderFns } from "./houselist.vue?vue&type=template&id=53e241dc&scoped=true&"
import script from "./houselist.vue?vue&type=script&lang=js&"
export * from "./houselist.vue?vue&type=script&lang=js&"
import style0 from "./houselist.vue?vue&type=style&index=0&id=53e241dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e241dc",
  null
  
)

export default component.exports